
import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import React from 'react';

const buttonVariants = cva(
	'inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
	{
		variants: {
			variant: {
        // Primary -> Safety Orange
				default: 'bg-safety-orange text-white hover:bg-safety-orange-hover', 
        // Destructive -> Red (Standard)
				destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        // Outline -> Border Stone Grey, Text Navy Steal
				outline:
          'border border-stone-grey bg-white text-navy-steal hover:bg-slate-50',
        // Secondary -> Stone Grey
				secondary:
          'bg-stone-grey text-white hover:bg-stone-grey/80',
        // Ghost -> Text Navy Steal, Hover background light
				ghost: 'text-navy-steal hover:bg-slate-100 hover:text-navy-steal',
        // Link -> Safety Orange
				link: 'text-safety-orange underline-offset-4 hover:underline',
			},
			size: {
				default: 'h-10 px-4 py-2',
				sm: 'h-9 rounded-md px-3',
				lg: 'h-11 rounded-md px-8',
				icon: 'h-10 w-10',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	},
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
	const Comp = asChild ? Slot : 'button';
	return (
		<Comp
			className={cn(buttonVariants({ variant, size, className }))}
			ref={ref}
			{...props}
		/>
	);
});
Button.displayName = 'Button';

export { Button, buttonVariants };
